import React, { useContext, useState, useEffect } from "react";
import classes from "./Login.module.scss";
import favicon from "../../../assets/images/favicon.png";
import InputText from "../../../components/Inputs/InputText";
import * as h from "../../../helpers";
import RoundButton from "../../../components/Buttons/RoundButton";
import Spinner from "../../../components/Spinner";
import * as d from "../../../constants/defaults";
import * as r from "../../../constants/routes"
import { useNavigate, useLocation } from "react-router";
import LoginContext from "../../../context/loginContext";
import Alert from "../../../components/Alerts";
import { R_A_USERS_LIST } from "../../../constants/routes";
import { useTranslation } from "react-i18next";
import AlertDialog from "../../../components/AlertDialog";
import Logo from "../../../assets/images/logo.png";
import ButtonLink from "../../../components/Buttons/ButtonLink";
import LoginBanner from "../../LoginAccess/LoginBanner/index";

export default function Login() {
  // #01 Hooks
  const context = useContext(LoginContext);
  const location = useLocation();
  const { t } = useTranslation();
  const history = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, []);
  // #02 Startups
  const { company_uid } = h.getQueryStringParams(location.search);
  // #03 States
  const [pw, setPw] = useState("");

  const backToHome = () => history(r.R_U_ROOT);

  const loginActionHandler = (event?: any) => {
    context.authSignInHandler({
      company_uid: company_uid,
      event: event,
      pw: pw,
      history,
      route: R_A_USERS_LIST,
    });
  };

  return (
    <div className={classes.Login}>
      <div className={classes.LoginBanner}>
        <LoginBanner />
      </div>
      <div className={classes.LoginForm}>
        <form
          className={classes.TagCard}
          onSubmit={(e) => {
            e.preventDefault();
            loginActionHandler(e);
          }}
        >
          <div
            className={classes.Logo}
            style={{ backgroundImage: `url(${Logo})` }}
          />
          <p className={classes.Subtitle}>{t("global.access_your_administrator_account")}</p>
          <InputText
            fake={context.loading}
            label={t("global.email")}
            onChange={context.setUsername}
            required={true}
            type={d.EMAIL}
            value={context.username}
          />
          <InputText
            fake={context.loading}
            label={t("global.password")}
            onChange={setPw}
            required
            type={d.PASSWORD}
            value={pw}
            showPWIcon
          >
            <a className={classes.SmallLinkLeft} href="/redefinicao_senha">
              {t("global.forgot_password")}
            </a>
          </InputText>

          <br />
          {/* <a className={classes.NeedHelp} href="%PUBLIC_URL%/favicon.ico">
          {t("global.do_you_need_help")}
        </a> */}
          {context.msg_error && !context.loading && (
            <Alert text={context.msg_error} danger />
          )}
          {context.loading ? (
            <Spinner center />
          ) : (
            <div className={classes.FormButton}>
              <RoundButton
                huge
                type={d.SUBMIT}
                text={t("global.enter")}
                title={"global.press_to_enter"}
              />
              <ButtonLink onClick={backToHome}>{t("global.back")}</ButtonLink>
            </div>
          )}
        </form>
        <AlertDialog
          textButton={t("global.do_you_need_help")}
          isConfirm={false}
          isInfo={true}
          isButtonText={true}
          textDialogPrimary={t("global.do_you_need_help")}
          textDialogSecondary={t("global.do_you_need_help_info1")}
        />
      </div>

    </div>
  );
}
